import yup from "lib/yup-extended";

export const validations = yup.object({
  products: yup
    .array()
    .when('interestPlan', (interestPlan, schema) =>
      !!interestPlan[0].length ? schema : schema.min(1, "Selecione pelo menos uma solução."))
});
